<script lang="ts">

    import {createEventDispatcher} from "svelte";
    import type {IAddress} from "../../interfaces";

    export let data: IAddress;
    export let enableSelect: boolean = false;
    export let enableRemove: boolean = false;

    let dispatch = createEventDispatcher();

    function edit() {
        dispatch('edit');
    }

    function remove() {
        dispatch('remove');
    }

    function activate() {
        data.selected = !data.selected;
        dispatch('select')
    }

</script>

<div class="border p-iii box-b mb-1">
    <div on:click={activate} class="flex-100">
        <div class="box-l sx-ii">
            {#if enableSelect}
                <div class="box self-start">
                    {#if data.selected}
                        <img height="24" width="24" src="/static/storefront/pix/material/check_circle.svg" alt="Checked">
                    {:else}
                        <img height="24" width="24" src="/static/storefront/pix/material/circle.svg" alt="No Checked">
                    {/if}
                </div>
            {/if}
            <p>{data.address}
                <br>{data.city?.name}<br>
                {data.details || ""}
            </p>
        </div>
    </div>
    <div class="self-start">
        <div class="address-action box sx-ii mb-1" on:click={edit}>
            <img height="18" src="/static/storefront/pix/icons/editar.svg" alt="Editar">
            <div>Editar</div>
        </div>
        {#if enableRemove}
            <div class="address-action box sx-ii" on:click={remove}>
                <img height="18" src="/static/storefront/pix/icons/eliminar.svg" alt="Eliminar">
                <div>Eliminar</div>
            </div>
        {/if}
    </div>
</div>
<style>
    .address-action {
        background: #fafafa;
        padding: .5rem;
        font-size: 14px;
    }

    .address-action:active {
        background: var(--bg-gray);
    }
</style>